import React from "react";

const LeavePayDays = ({ withPay, withoutPay, onChange, disabled }) => {
  return (
    <div className="form-row">
      <div className="form-group">
        <label>With Pay No of Days:</label>
        <input
          type="number"
          value={withPay}
          onChange={(e) => onChange("withPay", e.target.value)}
          disabled={disabled}
        />
      </div>

      <div className="form-group">
        <label>Without Pay No of Days:</label>
        <input
          type="number"
          value={withoutPay}
          onChange={(e) => onChange("withoutPay", e.target.value)}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default LeavePayDays;
